export default function float(n) {
  return parseFloat(n).toFixed(1);
}